import { render, staticRenderFns } from "./internal_files.vue?vue&type=template&id=611f52fc&scoped=true&"
import script from "./internal_files.vue?vue&type=script&lang=js&"
export * from "./internal_files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611f52fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('611f52fc')) {
      api.createRecord('611f52fc', component.options)
    } else {
      api.reload('611f52fc', component.options)
    }
    module.hot.accept("./internal_files.vue?vue&type=template&id=611f52fc&scoped=true&", function () {
      api.rerender('611f52fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/internal_docs/edit/tabs/internal_files.vue"
export default component.exports